/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Enrich_Pending_BannerInputs */

const en_directory_submit_enrich_pending_banner = /** @type {(inputs: Directory_Submit_Enrich_Pending_BannerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your tool has been submitted and is awaiting review.`)
};

const zh_directory_submit_enrich_pending_banner = /** @type {(inputs: Directory_Submit_Enrich_Pending_BannerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你的工具已提交，正在等待审核。`)
};

/**
* | output |
* | --- |
* | "Your tool has been submitted and is awaiting review." |
*
* @param {Directory_Submit_Enrich_Pending_BannerInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_enrich_pending_banner = /** @type {((inputs?: Directory_Submit_Enrich_Pending_BannerInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Enrich_Pending_BannerInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_enrich_pending_banner(inputs)
	return zh_directory_submit_enrich_pending_banner(inputs)
});
export { directory_submit_enrich_pending_banner as "directory.submit.enrich.pending_banner" }